export interface AiPromptBoxAttachmentsProps {
  id: string;
}

export type PromptAttachment = UserImageAttachment | DesignAttachment | ExampleImageAttachment | ReattachedModelImageAttachment;

export enum PendingUploadStatus {
  UPLOADING = 'uploading',
  FAILED = 'failed',
}

export interface PendingUpload {
  blobUrl: string;
  status: PendingUploadStatus;
}

export interface UserImageAttachment {
  hashedFilename: string;
  extension: string;
  source: string;
  width?: number;
  height?: number;
  type: PromptAttachmentType.IMAGE | PromptAttachmentType.CAPTURE_PHOTO;
  localId?: string;
  pendingUpload?: PendingUpload;
}

export interface ExampleImageAttachment {
  type: PromptAttachmentType.EXAMPLE_IMAGE;
  fileName: string;
}

export interface DesignAttachment {
  designId: string;
  type: PromptAttachmentType.DESIGN | PromptAttachmentType.DESIGN_TEMPLATE;
  previewURL: string;
  pageHashedId?: string;
}

export interface ReattachedModelImageAttachment {
  type: PromptAttachmentType.REATTACHED_MODEL_IMAGE;
  imageHashedId: string;
}

export enum PromptAttachmentType {
  IMAGE = 'image',
  DESIGN = 'design',
  DESIGN_TEMPLATE = 'design-template',
  CAPTURE_PHOTO = 'capture-photo',
  EXAMPLE_IMAGE = 'example-image',
  UPLOAD_FROM_DEVICE = 'upload-from-device',
  REATTACHED_MODEL_IMAGE = 'reattached-model-image',
}

export enum PromptAttachmentDivider {
  HORIZONTAL_LINE = 'horizontal-line',
}

export enum NavigationDirection {
  NEXT = 1,
  PREVIOUS = -1,
}

export type AttachmentDropdownConfig = (PromptAttachmentType | PromptAttachmentDivider)[];

export interface LoadingAttachment {
  id: string;
}

export interface AiPromptBoxAttachments {
  items: PromptAttachment[];
  dropdown: AttachmentDropdownConfig;
}
